import React from "react";
import { Layout } from 'antd';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';
import useGetCurrentWebsite from "../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite";
import DomainContentAnalysis from "../contentAnalysis/ContentAnalysis";

const { Content } = Layout;


export default function AIContentAnalysisPage() {
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const domain = selectedWebsite?.domain || "";

    return (
        <Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                {domain ? <DomainContentAnalysis domain={domain} /> : null}
            </WebsiteIndexEntryTabs>
        </Content>
    );
}